import { Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import SuspenseLoader from "./common/Layout/SuspenseLoader/SuspenseLoader";
import { useLocation } from "react-router-dom";
import { makeRequest } from "./services/api";
import ReactGA from "react-ga4";

ReactGA.initialize("G-8R7JH10WFR");
// ReactGA.initialize("G-J39T4L33DT");
// ReactGA.initialize("G-F55KNR2DWC");
// ReactGA.initialize("G-PH5V1KN581");

function App() {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [desktop, setDesktop] = useState([]);
    const [web, setWeb] = useState([]);
    const [tab, setTab] = useState([]);
    const [mobile, setMobile] = useState([]);
    const [currentImages, setCurrentImages] = useState([]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        const fetchData = async () => {
            try {
                const CATEGORYID = "66f186046ac06aadbb1b2799";
                const response = await makeRequest("post", "/cms/herobanner", { categoryId: CATEGORYID });

                if (response.data) {
                    const mappedData = response.data.map(item => ({
                        mediaUrls: {
                            desktop: item.desktop?.url || null,
                            web: item.web?.url || null,
                            tab: item.tab?.url || null,
                            mobile: item.mobile?.url || null,
                        },
                    }));

                    setDesktop(mappedData.map(item => item.mediaUrls.desktop).filter(url => url));
                    setWeb(mappedData.map(item => item.mediaUrls.web).filter(url => url));
                    setTab(mappedData.map(item => item.mediaUrls.tab).filter(url => url));
                    setMobile(mappedData.map(item => item.mediaUrls.mobile).filter(url => url));
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getImageSet = () => {
        if (windowWidth >= 1440) return desktop;
        if (windowWidth >= 1024) return web;
        if (windowWidth >= 834) return tab;
        return mobile;
    };

    useEffect(() => {
        setCurrentImages(getImageSet());
    }, [windowWidth, desktop, web, tab, mobile]);

    const TrackLocation = () => {
      const location = useLocation();
  
      useEffect(() => {
        const prevPath = sessionStorage.getItem("currentPath");
        sessionStorage.setItem("prevPath", prevPath);
        sessionStorage.setItem("currentPath", location.pathname);
  
        ReactGA.send({ hitType: "pageview", page: location.pathname });
      }, [location.pathname]);
  
      return null;
    };

  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Router basename={process.env.REACT_APP_BASENAME}>
      <TrackLocation />
        <AppRoutes currentImages={currentImages}/>
      </Router>
    </Suspense>

  );
}

export default App;













// import { Suspense, useEffect, useState } from "react";
// import { BrowserRouter as Router } from "react-router-dom";
// import AppRoutes from "./routes";
// import SuspenseLoader from "./common/Layout/SuspenseLoader/SuspenseLoader";
// import { useLocation } from "react-router-dom";
// import { makeRequest } from "./services/api";

// function App() {

//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//     const [desktop, setDesktop] = useState([]);
//     const [web, setWeb] = useState([]);
//     const [tab, setTab] = useState([]);
//     const [mobile, setMobile] = useState([]);
//     const [currentImages, setCurrentImages] = useState([]);

//     useEffect(() => {
//         const handleResize = () => {
//             setWindowWidth(window.innerWidth);
//         };

//         window.addEventListener("resize", handleResize);

//         const fetchData = async () => {
//             try {
//                 const CATEGORYID = "66f186046ac06aadbb1b2799";
//                 const response = await makeRequest("post", "/cms/herobanner", { categoryId: CATEGORYID });

//                 if (response.data) {
//                     const mappedData = response.data.map(item => ({
//                         mediaUrls: {
//                             desktop: item.desktop?.url || null,
//                             web: item.web?.url || null,
//                             tab: item.tab?.url || null,
//                             mobile: item.mobile?.url || null,
//                         },
//                     }));

//                     setDesktop(mappedData.map(item => item.mediaUrls.desktop).filter(url => url));
//                     setWeb(mappedData.map(item => item.mediaUrls.web).filter(url => url));
//                     setTab(mappedData.map(item => item.mediaUrls.tab).filter(url => url));
//                     setMobile(mappedData.map(item => item.mediaUrls.mobile).filter(url => url));
//                 }
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//             }
//         };

//         fetchData();

//         return () => {
//             window.removeEventListener("resize", handleResize);
//         };
//     }, []);

//     const getImageSet = () => {
//         if (windowWidth >= 1440) return desktop;
//         if (windowWidth >= 1024) return web;
//         if (windowWidth >= 834) return tab;
//         return mobile;
//     };

//     useEffect(() => {
//         setCurrentImages(getImageSet());
//     }, [windowWidth, desktop, web, tab, mobile]);

//   const TrackLocation = () => {
//     const location = useLocation();

//     useEffect(() => {
//         const prevPath = sessionStorage.getItem("currentPath");
//         sessionStorage.setItem("prevPath", prevPath);
//         sessionStorage.setItem("currentPath", location.pathname);
//     }, [location.pathname]);

//     return null;
//   };

//   return (
//     <Suspense fallback={<SuspenseLoader />}>
//       <Router basename={process.env.REACT_APP_BASENAME}>
//       <TrackLocation />
//         <AppRoutes currentImages={currentImages}/>
//       </Router>
//     </Suspense>

//   );
// }

// export default App;
